/*
 * @Author: Hugo
 * @Date: 2021-02-01 15:25:46
 * @LastEditTime: 2021-03-12 17:05:22
 * @LastEditors: Please set LastEditors
 * @Description: 卡片
 * @FilePath: /Workbench_Front_Support/src/workbench_front/layout/headerComponents/AllApps/CardItem/index.js
 */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { langCheck } from 'Pub/js/utils';
import _ from 'lodash';
import { Card } from 'antd';

import './index.less';

class CardItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: this.props.expanded,
            focused: this.props.focused
        };
    }
    componentDidMount() {

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.expanded !== this.props.expanded) {
            this.setState({ expanded: nextProps.expanded });
        }
    }
    // 扩展按钮
    renderExtra = () => {
        let { className, title } = this.props;
        let { expanded } = this.state;
        return (
            <div class="wb-card-extra" onClick={this.onCardExpand}>
                {/* icon-jiantoushang1|icon-jiantouxia1 */}
                <i
                    className={`iconfont icon-jiantouyou ${expanded === true ? 'icon-transform' : ''}`}
                />
            </div>
        );
    }
    // 标题
    renderTitle = () => {
        let { title } = this.props;
        return (
            <div className="wb-card-head-title" onClick={this.onCardExpand}>
                {title}
            </div>
        );
    }
    // 标题点击事件
    onCardExpand = (e) => {
        let { expanded } = this.state;
        let { onExpanded, isMyApp } = this.props;
        if (isMyApp) {
            onExpanded(false)
            return;
        }
        expanded = !expanded;
        this.setState({
            expanded: expanded
        });
        onExpanded && onExpanded(expanded);
    }

    renderBody = () => {
        let { children } = this.props;
        const { expanded } = this.state;
        return (
            <div className="wb-card-body">
                {children}
            </div>
        )
    }

    render() {
        let { className } = this.props;
        let { expanded, focused } = this.state;
        return (
            <div className={'wb-card-item ' + (expanded ? '' : 'collapsed ') + (className || '') + (focused ? ' focused' : '')}>
                <div className="wb-card-head">
                    <div className="wb-card-head-wrapper">
                        {this.renderTitle()}
                        {this.renderExtra()}
                    </div>
                </div>
                {this.renderBody()}
            </div>
        );
    }
}

CardItem.propTypes = {
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    expanded: PropTypes.bool,
    onExpanded: PropTypes.func,

};
CardItem.defaultProps = {
    expanded: true
};

export default CardItem;
